import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import LearningPathCreate from 'pages/creator/learning_paths/learning_path_create';
import { LearningPathStore } from '@seedlang/stores';
import Paginator from 'components/paginator';
import DeleteButton from 'components/button/delete_button';
import autobind from 'autobind-decorator';
import { Link } from 'react-router';
import InPlaceText from 'components/form/in_place_text';
import InPlaceCheckbox from 'components/form/in_place_checkbox';
import { AppUI } from '@seedlang/state';
import Spinner from 'components/spinner';
import PageTitle from 'components/common/page_title';
import WelcomeScreen from 'components/learning_path/welcome_screen';
import { gaps } from 'components/layout/stack';
import Grid from 'components/layout/grid';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${gaps.sm};

  table {
    margin-top: 20px;
  }
`;

const WelcomeScreenWrapper = styled.div`
  padding: ${gaps.md};
`;

const SignedInCheckboxLabel = styled.label`
  display: flex;
  gap: ${gaps.xs};
  text-transform: none !important;
  font-size: initial !important;
`;

@observer
class LearningPathIndex extends React.Component {

  @observable previewSignedIn = false;

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.getLearningPaths();
  }

  componentWillUnmount() {
    LearningPathStore.clearIndexData();
  }

  @autobind onDelete(id) {
    LearningPathStore.destroy({ids: {learningPathId: id}}, this.getLearningPaths);
  }

  @autobind getLearningPaths() {
    LearningPathStore.getIndex();
  }

  @autobind reloadSite() {
    AppUI.loadUser();
  }

  @autobind onToggleSignedIn() {
    this.previewSignedIn = !this.previewSignedIn;
  }

  render() {
    return (
      <Wrapper>
        <PageTitle>Learning Paths</PageTitle>
        <LearningPathCreate
          afterCreate={this.getLearningPaths}
        />
        {
          LearningPathStore.requestCounter > 0 &&
          <Spinner background={AppUI.site.accentColor} />
        }
        <table className='table-wrapper admin-table'>
          <thead>
            <tr>
              <th width='20' />
              <th>Position</th>
              <th>Name</th>
              <th>Published</th>
              <th>Posts Count</th>
              <th width='40'></th>
            </tr>
          </thead>
          <tbody>
            {
              LearningPathStore.indexData.map(item => {
                return (
                  <tr key={item.id}>
                    <td>
                      <Link
                        to={{ name: 'creator.learning_paths.edit', params: { learningPathId: item.id } }}
                        className='on-click'
                      >
                        <i className='fa fa-chevron-right fa-block' />
                      </Link>
                    </td>
                    <td style={{width: '100px'}}>
                      <div className='text'>
                        <InPlaceText
                          type='number'
                          field='position'
                          defaultValue={item.position}
                          model='learning_paths'
                          id={item.id}
                          afterChange={this.getLearningPaths}
                        />
                      </div>
                    </td>
                    <td>
                      <div className='text' style={{display: 'flex'}}>
                        <InPlaceText
                          field='name'
                          defaultValue={item.name}
                          model='learning_paths'
                          id={item.id}
                        />
                      </div>
                    </td>
                    <td>
                      <InPlaceCheckbox
                        field='published'
                        value={item.published}
                        model='learning_paths'
                        id={item.id}
                        afterChange={this.getLearningPaths}
                      />
                    </td>
                    <td>
                      <div className='text'>
                        {item.worksheetsCount}
                      </div>
                    </td>
                    <td>
                      <DeleteButton
                        onConfirm={() => this.onDelete(item.id)}
                        message='Delete this learning path?'
                        className='fa-block right'
                      />
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
        <Paginator
          store={LearningPathStore}
        />
        <Grid columns={2} gap='sm'>
          <InPlaceText
            legend='Welcome Title (Signed In)'
            field='learning_paths_welcome_title_signed_in'
            defaultValue={AppUI.site.learningPathsWelcomeTitleSignedIn}
            model='sites'
            id={AppUI.site.id}
            afterChange={this.reloadSite}
          />
          <InPlaceText
            legend='Welcome Title (Signed Out)'
            field='learning_paths_welcome_title_signed_out'
            defaultValue={AppUI.site.learningPathsWelcomeTitleSignedOut}
            model='sites'
            id={AppUI.site.id}
            afterChange={this.reloadSite}
          />
          <InPlaceText
            legend='Welcome Subtitle (Signed In)'
            field='learning_paths_welcome_subtitle_signed_in'
            defaultValue={AppUI.site.learningPathsWelcomeSubtitleSignedIn}
            model='sites'
            id={AppUI.site.id}
            afterChange={this.reloadSite}
          />
          <InPlaceText
            legend='Welcome Subtitle (Signed Out)'
            field='learning_paths_welcome_subtitle_signed_out'
            defaultValue={AppUI.site.learningPathsWelcomeSubtitleSignedOut}
            model='sites'
            id={AppUI.site.id}
            afterChange={this.reloadSite}
          />
        </Grid>
        <fieldset>
          <legend>Welcome Screen Preview</legend>
          <SignedInCheckboxLabel>
            <input
              type='checkbox'
              checked={this.previewSignedIn}
              onChange={this.onToggleSignedIn}
            />
            Signed In
          </SignedInCheckboxLabel>
          <WelcomeScreenWrapper>
            <WelcomeScreen
              learningPaths={LearningPathStore.indexData.filter(item => item.published)}
              signedIn={this.previewSignedIn}
            />
          </WelcomeScreenWrapper>
        </fieldset>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(LearningPathIndex);